<ul class="votes" [class.small-rate]="answers.length > 4">
  <li
    class="vote-rate"
    *ngFor="let answer of answers"
    [style.background]="answer.rate | pollFill : isFinished"
  >
    <div class="answer">
      <span #answer [toolTipWidth]="200" [customToolTip]="answer.text" class="body-3 marker">{{ answer.text }}</span>
      <span class="votes-number" [class.leader-icon]="isFinished">{{ answer.votes }}</span>
    </div>

    <div class="rate">
      <svg [icon]="icons.Selected" class="svg18 mr4 leader-icon" *ngIf="answer.leader && isFinished"/>
      <div class="body-3">{{ answer.rate }} %</div>
    </div>
  </li>
</ul>
